import React from 'react'
import { SEO, PrimaryLayout, PageHeader } from '../../components'
import { buildStaticProps } from 'ssg/posts'

const sitemapLinks = [
  { path: '/', label: 'Home' },
  { path: '/about/', label: 'About' },
  { path: '/ca-privacy-notice/', label: 'CA Privacy Notice' },
  { path: '/direct/', label: 'Direct' },
  {
    path: '/do-not-sell-my-personal-information/',
    label: 'Do Not Sell My Personal Information',
  },
  { path: '/international/', label: 'International' },
  { path: '/partner/', label: 'Partner' },
  { path: '/privacy-policy/', label: 'Privacy Policy' },
  { path: '/terms-conditions/', label: 'Terms & Conditions' },
  {
    path: '/non-discrimination-statement/',
    label: 'Non-Discrimination Statement',
  },
  { path: '/accessibility/', label: 'Accessibility' },
]

function Sitemap({ posts }: any) {
  const addedLinks = posts.map(
    (link: { slug: string; title: string; categories: string[] }) => ({
      path: `/guides/${link?.categories?.[0].replace(
        /\W+(?!$)/g,
        '-',
      )}/${link.slug}`,
      label: link.title,
    }),
  )
  return (
    <>
      <SEO
        title="Ratequote - Website Sitemap"
        description="A comprehensive list of all pages on our website."
      />
      <PrimaryLayout>
        <PageHeader
          category="RateQuote"
          date={new Date().toISOString()} // Using current date as an example; adjust as needed
          title="RateQuote - Site Map"
        />
        <div className="max-w-3-1/2xl mx-auto flex w-full flex-col px-5 pb-52 sm:px-0 md:flex-row md:space-x-6">
          <div className="md:pl-20 lg:pl-24 xl:pl-28">
            <h2 className="mb-4 text-center md:text-left">Website Pages</h2>
            <ul className="list-inside list-decimal">
              {[...sitemapLinks, ...addedLinks].map((link) => (
                <li
                  key={link.path}
                  className="c-sanity-p mb-6 list-none text-center md:text-left
                  "
                >
                  <a
                    className="text-gray-400" // Set color to light gray
                    style={{ textDecoration: 'underline' }} // Remove decoration
                    href={link.path}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </PrimaryLayout>
    </>
  )
}

export async function getServerSideProps() {
  const { props } = await buildStaticProps()

  return { props }
}

export default Sitemap
